var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[(_vm.stories.length)?_vm._l((_vm.stories),function(story){return _c('news-story',{key:story.id,attrs:{"story":story}})}):_c('div',{staticClass:"no-news"},[_vm._v("No news found")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }